<section class="page-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin Contact Requests</span>
        <h1>RFQ and contact submissions.</h1>
        <p>View customer requests and update their status.</p>
    </div>
</section>

<section class="section">
    <div class="container">

        <div style="margin-bottom:24px">
            <a class="learn" routerLink="/admin/dashboard">← Back to dashboard</a>
        </div>

        <div *ngIf="successMessage" class="alert success" style="margin-bottom:16px">
            {{ successMessage }}
        </div>

        <div *ngIf="errorMessage" class="alert error" style="margin-bottom:16px">
            {{ errorMessage }}
        </div>

        <div class="contact-grid">

            <aside>
                <span class="section-kicker">Requests</span>
                <h2 style="font-size:34px">Incoming RFQs.</h2>

                <div *ngIf="loading">Loading requests...</div>

                <div class="office-card premium-office" *ngFor="let r of requests">
                    <h3>{{ r.fullName }}</h3>
                    <p>{{ r.company || '-' }} / {{ r.serviceCategory }}</p>
                    <span>{{ r.status }} • {{ r.priority }}</span>

                    <div style="display:flex;gap:8px;margin-top:14px;flex-wrap:wrap">
                        <button class="btn btn-ghost" type="button" (click)="view(r)">
                            View
                        </button>

                        <button class="btn btn-ghost" type="button" (click)="updateStatus(r, 'READ')">
                            Read
                        </button>

                        <button class="btn btn-dark" type="button" (click)="updateStatus(r, 'COMPLETED')">
                            Completed
                        </button>
                    </div>
                </div>
            </aside>

            <main class="quote-panel">
                <ng-container *ngIf="selected; else emptyState">
                    <span class="section-kicker">Request Detail</span>
                    <h2 style="font-size:32px;margin-top:8px">{{ selected.fullName }}</h2>

                    <div class="feature-list">
                        <div class="feature">
                            <span class="check">✓</span>
                            <div>
                                <b>Company</b><br>
                                <span>{{ selected.company || '-' }}</span>
                            </div>
                        </div>

                        <div class="feature">
                            <span class="check">✓</span>
                            <div>
                                <b>Email</b><br>
                                <span>{{ selected.email }}</span>
                            </div>
                        </div>

                        <div class="feature">
                            <span class="check">✓</span>
                            <div>
                                <b>Phone</b><br>
                                <span>{{ selected.phone || '-' }}</span>
                            </div>
                        </div>

                        <div class="feature">
                            <span class="check">✓</span>
                            <div>
                                <b>Service / Priority</b><br>
                                <span>{{ selected.serviceCategory }} / {{ selected.priority }}</span>
                            </div>
                        </div>

                        <div class="feature">
                            <span class="check">✓</span>
                            <div>
                                <b>Status</b><br>
                                <span>{{ selected.status }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="field full" style="margin-top:18px">
                        <label>Requirement</label>
                        <textarea readonly [value]="selected.message"></textarea>
                    </div>

                    <div style="display:flex;gap:8px;margin-top:14px;flex-wrap:wrap">
                        <button class="btn btn-ghost" type="button" (click)="updateStatus(selected, 'READ')">
                            Mark as Read
                        </button>

                        <button class="btn btn-primary" type="button" (click)="updateStatus(selected, 'COMPLETED')">
                            Mark Completed
                        </button>
                    </div>
                </ng-container>

                <ng-template #emptyState>
                    <span class="section-kicker">Request Detail</span>
                    <h2 style="font-size:32px;margin-top:8px">Select a request</h2>
                    <p style="color:var(--muted)">Click “View” on the left side to see request details.</p>
                </ng-template>
            </main>

        </div>

    </div>
</section>